import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

const ALL_LINKS = [
  { label: "Kloakopgaver", to: "/ydelser/kloakopgaver" },
  { label: "Serviceaftale", to: "/ydelser/serviceaftale" },
  { label: "No-dig", to: "/ydelser/no-dig" },
  { label: "Spul & Rens", to: "/ydelser/spul-rens" },
];

export const Rotter = () => (
  <>
    <SEO
      title="Rottebekæmpelse – Certificeret rottefænger i Nordsjælland"
      description="Certificeret rottebekæmpelse: lokalisering, sikring, bekæmpelse og dokumentation af rotter i kloak og bygning. Vi finder årsagen og forebygger gentagelse."
    />
    <ServicePageTemplate
    eyebrow="Rottebekæmpelse"
    title={<>Vi finder vejen ind, <em className="text-[color:var(--fk-gold)]">før vi lukker den.</em></>}
    subtitle="Som certificeret rottefænger arbejder vi systematisk med at lokalisere aktivitet, finde årsagen og sikre de steder, hvor rotterne kommer ind. Vi bekæmper ikke kun problemet, vi dokumenterer det og hjælper med at forebygge, at det vender tilbage."
    heroImage={ASSETS.images.rats}
    intro="Rotter kommer sjældent alene, og de forsvinder sjældent af sig selv. Vi finder årsagen, lukker adgangsvejene og sikrer din ejendom mod gentagelser."
    bullets={[
      "Lokalisering af aktivitet med TV-inspektion og røgprøver",
      "Sikring af kloak, bygning og indtrængningsveje",
      "Bekæmpelse efter gældende regler og faglige standarder",
      "Klar dokumentation til forsikring, myndighed eller ejer",
    ]}
    process={[
      { title: "Opkald", body: "Vi afklarer situationen, vurderer behovet og aftaler første besøg — også som døgnvagt." },
      { title: "Lokalisering", body: "Vi finder kilden i kloak eller bygning med TV-inspektion, røgprøver og faglig erfaring." },
      { title: "Bekæmpelse", body: "Vi bekæmper problemet og sikrer de udsatte adgangsveje efter gældende regler." },
      { title: "Dokumentation", body: "Du får klar dokumentation på arbejdet, så sagen kan bruges overfor forsikring, myndighed eller ejer." },
    ]}
    ctaHeading="Brug for hjælp med rotter?"
    ctaBody="Ring til døgnvagten, hvis du har mistanke om rotter i kloak, bygning eller på ejendommen. Vi afklarer situationen og rykker ud, når der er behov for det."
    related={ALL_LINKS}
  />
  </>
);
